import { render, staticRenderFns } from "./modifyMailbox.vue?vue&type=template&id=1bf2bd92&scoped=true"
import script from "./modifyMailbox.vue?vue&type=script&lang=js"
export * from "./modifyMailbox.vue?vue&type=script&lang=js"
import style0 from "./modifyMailbox.vue?vue&type=style&index=0&id=1bf2bd92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2bd92",
  null
  
)

export default component.exports